<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { Image } from '@sanity/types';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    tiles: Array<any>;
    variant?: string;
    size?: string;
    image?: Image;
    subImage?: Image;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  type: props.block?._type,
  tiles: props.block?.tiles,
  variant: props.block?.variant,
  size: props.block?.size,
  image: props.block?.image,
  subImage: props.block?.subImage,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data" class="solutions-tiles" />
</template>

<style scoped>
.solutions-tiles {
  --rows-override: 1;

  @screen tablet-wide {
    --rows-override: 2;
  }
}
</style>
